import { ErrorResponse } from '~shared/models';
import { Filters } from '../../models';

export interface FiltersState {
  payload: Filters;
  loading: boolean;
  error: ErrorResponse;
}

export const filtersInitialState: FiltersState = {
  payload: {
    categories: [],
    categoriesNext: [],
    priceRange: { min: null, max: null },
    attributes: [],
    promotion: null,
    volumePrices: null,
    blackFriday: null,
  },
  loading: false,
  error: null,
};
